<template>
  <slot/>
</template>

<script>
export default {
  name: 'CheckoutLayout'
}
</script>

<style>
@import './../assets/css/checkout.css';

</style>
